import { SVGIcon } from '@shared/Frontend/components/svg'
import * as React from 'react'
import { StyleguideTokenPart, StyleguideTokenRow } from '../../../../../Shared/Hoppinger.Styleguide/Frontend'
import { svgIconNames } from '../../../../../svgIcons'

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const TokensIcons = () => (
  <StyleguideTokenPart hasAttributeColumn={false} hasExampleColumn={true}>
    {svgIconNames.map((i, index) => {
      const isProject = i.startsWith('project')
      return (
        <StyleguideTokenRow
          key={index}
          code={`#${i}`}
          columnCount={2}
          hasSeparator={false}
          hasExample={true}
          extraClasses={undefined}
        >
          <SVGIcon className="styleguide-token__icon" id={i} size={isProject ? 80 : undefined} />
        </StyleguideTokenRow>
      )
    })}
  </StyleguideTokenPart>
)
